import apiService from '@/services/apiService';

const actions = {
  getBenefits({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postActivation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`paxelian-club/benefit/activation/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/benefit/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteBenefit({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService.delete(`paxelian-club/benefit/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default actions;